import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import ContentCopy from '@mui/icons-material/FileCopy';
import { CREATE } from 'react-admin';
import { useNavigate } from 'react-router-dom';

import dataProvider from '../utils/dataProvider';
//import { templateDuplicate as templateDuplicateAction } from '../actions/templateDuplicateAction';

class DuplicateTemplateButton extends Component {
    handleClick = () => {
        const { push, record, showNotification } = this.props;

        var url = `templates/duplicate/${record.id}`;
        dataProvider(CREATE, url, { id: record.id }).then((response) => {
            console.log(response);
            showNotification("Template duplicated. You are now viewing the duplicated template.");
            push('/templates/' + response.data.id);
        })
        .catch((e) => {
            console.error(e);
            showNotification('Error: Template failed to duplicate.')
        });
    }

    render() {
        return <Button onClick={this.handleClick} size="small">
                    <ContentCopy/> Duplicate
               </Button>;
    }
}

DuplicateTemplateButton.propTypes = {
    record: PropTypes.object,
    push: PropTypes.func,
    showNotification: PropTypes.func,
};

export default DuplicateTemplateButton;